// KhufuDetail.js

import React from 'react';

import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import './projet.css';

function KhufuDetail() {

  const particlesInit = useCallback(async engine => {
    console.log(engine);
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async container => {
      await console.log(container);
  }, []);

  return (
    <div className='flex'>
      <a href="/" className='back'>Back to Main Page</a>
      <h1>Khufu's Escape</h1>
      <p className='center'><i>Develop with Unreal Engine 5.2</i></p>
      <iframe width="560" height="315" title='Introduction Video' src="https://www.youtube.com/embed/Rg-JLduAic4"  allowFullScreen></iframe>
      <div className='download'><a href="https://fl3ur.itch.io/khufus-escape" className='itchio'>Play the game on Itch.io</a></div>
      <div className="paragraph-container">
        <h3>Game Overview</h3>
        <p>Khufu’s Escape takes place in a contemporary setting to ours. The player embodies Khufu, an archaeologist trapped in the pyramid of the (less) famous pharaoh Toutankarthon, cursed by the latter to lose one of the most precious senses of a human being: 3D vision.</p>

        <h3>Gameplay</h3>
        <p>Khufu’s Escape is a side-scrolling platform game with puzzle-solving aspects. The unique feature of our game lies in the two different side-scrolling planes that allow the player to navigate through a 3D world.</p>

        <h3>Story</h3>
        <p>The game unfolds in the modern era, where Khufu, an archaeologist based in Cairo, decides to explore a recently discovered pyramid in the desert. Despite his initial doubts about his decision, he ultimately decides to be the first to venture inside the pyramid, hoping that his name will become globally recognized. However, barely has he had time to enter inside when he falls into a trap to land at the heart of the pyramid, where its tenant has resided for centuries, the pharaoh Toutankarthon.

Khufu openly mocks the cardboard pharaoh for his fragility and immobility due to a curse. The pharaoh, wounded in his pride, then curses Khufu, causing him to lose a dimension in his vision. Now, Khufu is trapped in the pyramid, just like the immobile pharaoh, and he realizes he must find a way out that keeps him imprisoned.

To do so, Khufu must escape the pyramid by avoiding traps, bypassing the pharaoh's guards patrolling inside, all while adapting to the curse that forces him to move in only one direction at a time.</p>

        <div className="columns">
        <div className="column">
            <h4>Developers</h4>
            <ul>
                <li>Alain Champigny</li>
                <li>Antoine Yebouet</li>
                <li>Maxime Wirth</li>
                <li>Thibault Boisseau</li>
            </ul>
        </div>

        <div className="column">
            <h4>Artist</h4>
            Léo Mougin
        </div>

        <div className="column">
            <h4>Sound Designer</h4>
            Antoine Yebouet
        </div>

        <div className="column">
            <h4>Supervisor</h4>
            Hamdi Ben Abdessalem, Ph. D.
        </div>
        </div>
      </div>
      <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
    </div>
  );
}

export default KhufuDetail;
